export const BLANK_DATES = ["0001-01-01", "0000-12-30"];
export const BLANK_ACTIVITY = "A";

// A regex used to separate the `activity` property of entries which may
// have several delimiters.
export const ACTIVITY_DELIMITER = /,|\/|\||~/;

export const SLIDE_MENU_OVERLAY_AUTO_CLOSE_MS = 30000;

export const SLIDE_MENU_OVERLAY_WIDTH_TRANSITION_MS = 600;

export const defaultLine2 = {
  content: "",
  options: { disableExternalLinks: false },
};

export const defaultDescription = {
  content: "",
  options: { disableExternalLinks: false },
};
